import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import * as Yup from 'yup';
// @mui
import LoadingButton from '@mui/lab/LoadingButton';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import InputAdornment from '@mui/material/InputAdornment';
import Link from '@mui/material/Link';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
// routes
import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';
// config
import {
  PATH_AFTER_LOGIN
} from 'src/config-global';
// hooks
import { useBoolean } from 'src/hooks/use-boolean';
// auth
// components
import { enqueueSnackbar } from 'notistack';
import { useDispatch } from 'react-redux';
import FormProvider, { RHFTextField } from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import { useLoginMutation } from '../../../store/Reducer/auth';
import { setUser } from '../../../store/slices/userSlice';

// ----------------------------------------------------------------------

export default function JwtLoginView() {
  const dispatch = useDispatch();

  const [loginData] = useLoginMutation();

  const router = useRouter();

  const [errorMsg, setErrorMsg] = useState('');

  const password = useBoolean();

  const LoginSchema = Yup.object().shape({
    email: Yup.string().required('Email is required').email('Email must be a valid email address'),
    password: Yup.string().required('Password is required'),
  });

  const defaultValues = {
    email: '',
    password: '',
  };

  const methods = useForm({
    resolver: yupResolver(LoginSchema),
    defaultValues,
  });

  const {
    reset,
    handleSubmit,
    formState: { isSubmitting },
  } = methods;

  const onSubmit = handleSubmit(async (data) => {
    try {
      const user_data = {
        email: data.email,
        password: data.password,
        deviceType: 'android',
        timezone: 'Asia/Karachi',
        deviceId: '123',
        userType: 'admin',
      };
      const response = await loginData(user_data).unwrap();

      if (!response.error) {
        enqueueSnackbar(response?.message || 'Login successfully', { variant: 'success' });
        dispatch(setUser(response?.data));
        router.push(PATH_AFTER_LOGIN);
        reset();
      }
    } catch (error) {
      reset();
      setErrorMsg(typeof error === 'string' ? error : error.message);
    }
  });

  const renderHead = (
    <Stack spacing={2} sx={{ mb: 5 }}>
      <Typography variant="h4">Sign in to Afsaneh's Joy</Typography>
    </Stack>
  );

  const renderForm = (
    <Stack spacing={2.5}>
      {!!errorMsg && <Alert severity="error">{errorMsg}</Alert>}

      <RHFTextField
        name="email"
        label="Email address"
        inputProps={{ style: { textTransform: 'lowercase' } }}
        InputLabelProps={{ shrink: true }}
      />

      <RHFTextField
        name="password"
        label="Password"
        type={password.value ? 'text' : 'password'}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton onClick={password.onToggle} edge="end">
                <Iconify icon={password.value ? 'solar:eye-bold' : 'solar:eye-closed-bold'} />
              </IconButton>
            </InputAdornment>
          ),
        }}
        InputLabelProps={{ shrink: true }}
      />

      <Link onClick={() => router.push(paths.auth.forgotPassword)} variant="body2" color="inherit" underline="always" sx={{ alignSelf: 'flex-end', cursor: 'pointer' }}>
        Forgot password?
      </Link>

      <LoadingButton
        fullWidth
        color="primary"
        size="large"
        type="submit"
        variant="contained"
        loading={isSubmitting}
      >
        Login
      </LoadingButton>
    </Stack>
  );

  return (
    <FormProvider methods={methods} onSubmit={onSubmit}>
      {renderHead}
      {renderForm}
    </FormProvider>
  );
}
